<edu-card class="settings-card">
  <h2 edu-card-title>Parent notifications</h2>
  <p class="desc">
    Choose how parents are notified for each event, by email, WhatsApp, both, or
    not at all.
  </p>

  <span class="hint" *ngIf="!canManage">You do not have permission to change these settings.</span>

  <div class="setting-block">
    <h3 class="setting-title">Missed Deadline Notifications</h3>
    <div class="mode-grid">
      <div
        *ngFor="let o of options"
        class="mode-card"
        [class.selected]="missedDeadline() === o.id"
        [class.disabled]="!canManage || isSaving()"
        (click)="selectMissedDeadline(o.id)"
      >
        <div class="mode-logo" [ngClass]="o.id">
          <ng-container *ngTemplateOutlet="modeIcon; context: { id: o.id }"></ng-container>
        </div>
        <div class="mode-info">
          <h4 class="mode-name">{{ o.label }}</h4>
          <p class="mode-sub">{{ o.sub }}</p>
        </div>
        <div class="check-circle">
          <svg *ngIf="missedDeadline() === o.id" width="10" height="10" viewBox="0 0 10 10">
            <polyline points="2,5 4,7.5 8,3" stroke="white" stroke-width="1.5"
              fill="none" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
        </div>
      </div>
    </div>
  </div>

  <div class="setting-block">
    <h3 class="setting-title">Absence Notifications</h3>
    <div class="mode-grid">
      <div
        *ngFor="let o of options"
        class="mode-card"
        [class.selected]="absence() === o.id"
        [class.disabled]="!canManage || isSaving()"
        (click)="selectAbsence(o.id)"
      >
        <div class="mode-logo" [ngClass]="o.id">
          <ng-container *ngTemplateOutlet="modeIcon; context: { id: o.id }"></ng-container>
        </div>
        <div class="mode-info">
          <h4 class="mode-name">{{ o.label }}</h4>
          <p class="mode-sub">{{ o.sub }}</p>
        </div>
        <div class="check-circle">
          <svg *ngIf="absence() === o.id" width="10" height="10" viewBox="0 0 10 10">
            <polyline points="2,5 4,7.5 8,3" stroke="white" stroke-width="1.5"
              fill="none" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
        </div>
      </div>
    </div>
  </div>
</edu-card>

<!-- Icon set, shared by both grids -->
<ng-template #modeIcon let-id="id">
  <ng-container [ngSwitch]="id">
    <!-- Off: ban / no-notifications icon -->
    <img *ngSwitchCase="'off'" class="off-icon" src="assets/icons/ban.svg" alt="Off" width="22" height="22" />

    <!-- Email: Gmail logo -->
    <img *ngSwitchCase="'email'" src="assets/icons/gmail.svg" alt="Gmail" width="26" />

    <!-- WhatsApp logo -->
    <img *ngSwitchCase="'whatsapp'" src="assets/icons/whatsapp.svg" alt="WhatsApp" width="22" height="22" />

    <!-- Both: Gmail + WhatsApp side by side -->
    <div *ngSwitchCase="'both'" class="both-icons">
      <img src="assets/icons/gmail.svg" alt="Gmail" width="19" />
      <img src="assets/icons/whatsapp.svg" alt="WhatsApp" width="16" height="16" />
    </div>
  </ng-container>
</ng-template>
